import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';
import 'swiper/modules/effect-fade.min.css';
import 'swiper/modules/autoplay.min.css';

addEventListener('DOMContentLoaded', () => {
    const swiperBlocks = document.querySelectorAll('.albert-slideshow-block');

    if (swiperBlocks === null || swiperBlocks.length === 0) {
      return;
    }
    
    swiperBlocks.forEach((s) => {
      const autoplay = Boolean(Number(s.getAttribute('data-autoplay')));
      const autoplayDelay = parseInt(s.getAttribute('data-autoplay-delay')) * 1000;
      const transitionEffect = s.getAttribute('data-transition-effect');

      const swiperCont = s.querySelector('.albert-slideshow-swiper');

      if (swiperCont !== null) {
        const options = {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          modules: [Autoplay, EffectFade, Navigation, Pagination],
          pagination: {
            el: swiperCont.querySelector('.swiper-pagination'),
          },
          navigation: {
            nextEl: swiperCont.querySelector('.swiper-button-next'),
            prevEl: swiperCont.querySelector('.swiper-button-prev'),
          },
        };

        if (autoplay) {
          options.autoplay = { delay: autoplayDelay };
        }

        if (transitionEffect !== '') {
          options.effect = transitionEffect;
        }

        console.log(options);

        new Swiper(swiperCont, options);
      }
    });
});
